// Shared category/priority constants & helpers

export const CATEGORIES = [
  { key: "follow_up", label: "Follow-up", color: "#D97706" },
  { key: "task", label: "Task", color: "#0F172A" },
  { key: "client_support", label: "Client Support", color: "#DC2626" },
  { key: "new_enquiry", label: "New Enquiry", color: "#2563EB" },
  { key: "opportunity", label: "Opportunity", color: "#7C3AED" },
  { key: "quotation", label: "Quotation", color: "#0F172A" },
  { key: "deadline_commitment", label: "Deadline Commitment", color: "#D97706" },
  { key: "urgent_attention", label: "Urgent Attention", color: "#DC2626" },
  { key: "general_communication", label: "General", color: "#64748B" },
  { key: "promotion", label: "Promotion", color: "#059669" },
];

export const PRIORITIES = [
  { key: "low", label: "Low" },
  { key: "medium", label: "Medium" },
  { key: "high", label: "High" },
  { key: "urgent", label: "Urgent" },
];

export const STATUSES = [
  { key: "pending", label: "Pending" },
  { key: "in_progress", label: "In Progress" },
  { key: "completed", label: "Completed" },
  { key: "rejected", label: "Rejected" },
];

export const categoryLabel = (k) =>
  CATEGORIES.find((c) => c.key === k)?.label || k;

export const categoryColor = (k) =>
  CATEGORIES.find((c) => c.key === k)?.color || "#64748B";

export const priorityClasses = (p) => {
  const map = {
    urgent:   "bg-red-50 text-red-700 border-red-200",
    high:     "bg-amber-50 text-amber-800 border-amber-200",
    medium:   "bg-slate-100 text-slate-700 border-slate-200",
    low:      "bg-slate-50 text-slate-500 border-slate-200",
  };
  return map[p] || map.medium;
};

const getDateFormat = () => {
  try {
    return localStorage.getItem("dateFormat") || "MM/DD/YYYY";
  } catch {
    return "MM/DD/YYYY";
  }
};

const formatDateWithPreference = (date) => {
  const format = getDateFormat();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const monthName = date.toLocaleDateString("en-US", { month: "short" });

  switch (format) {
    case "DD/MM/YYYY":
      return `${day}/${month}/${year}`;
    case "YYYY-MM-DD":
      return `${year}-${month}-${day}`;
    case "DD-MMM-YYYY":
      return `${day}-${monthName}-${year}`;
    case "MM/DD/YYYY":
    default:
      return `${month}/${day}/${year}`;
  }
};

export const formatRelative = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff/60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff/3600)}h ago`;
    return formatDateWithPreference(d);
  } catch { return iso; }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const dateStr = formatDateWithPreference(d);
    const timeStr = d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
    return `${dateStr} ${timeStr}`;
  } catch { return iso; }
};

// Strip WhatsApp numeric mention IDs like @202945845010538 from display text.
// These are internal phone-number handles inserted by the WhatsApp protocol —
// they add no value and confuse readers.
export const stripMentionIds = (text) => {
  if (!text) return text;
  return text.replace(/@\d{7,}/g, "").replace(/[ \t]{2,}/g, " ").trim();
};

export const chatTypeClasses = (type) => {
  const map = {
    group: "bg-blue-100 text-blue-700 border-blue-200",
    individual: "bg-slate-100 text-slate-700 border-slate-200",
  };
  return map[type] || map.individual;
};
